import { http } from '@utils/index';

// stripe price

const getPrices = () => {
	return http.get<StripePriceRes>('/public/stripe/prices');
};
export default getPrices;
